import Map, { useControl } from 'react-map-gl'
import { NavigationControl } from 'mapbox-gl'

interface NavigationControlEnhanced extends NavigationControl {
  _zoomInButton: HTMLButtonElement
  _zoomOutButton: HTMLButtonElement
}

const CustomNavigationControl = () => {
  useControl(() => {
    const container = new NavigationControl({
      showCompass: false
    }) as NavigationControlEnhanced

    container._zoomInButton.children[0].innerHTML =
      '<span class="mapboxgl-ctrl-button material-icons" title="Zoom In" aria-label="Zoom In">add</span>'

    container._zoomOutButton.children[0].innerHTML =
      '<span class="mapboxgl-ctrl-button material-icons" title="Zoom Out" aria-label="Zoom Out">remove</span>'

    return container
  })

  return null
}

export default CustomNavigationControl
